<template>
	<sf-card class="p-0 border-0 bg-transparent h-100">
		<variable-table />
	</sf-card>
</template>

<script>
import VariableTable from './Table/VariableTable.vue';
export default {
	components: { VariableTable }
};
</script>

<style></style>
